module.exports = __webpack_public_path__ + "static/media/cornerstone-white.b56b0bcb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cornerstone-white.svg
// module id = 266
// module chunks = 0